import { IconButton } from '@features/shared/components/IconButton'
import { EditIcon } from '@features/shared/icons/icons'
import { FavoriteTrail } from './FavoritesMenu'

/**
 * What Home's name card says after its name: the page Home opens, by its
 * trail (Tables › Accounts), and a pencil that opens the Home Page picker
 * beside it to change it (HomePageEditor).
 */
export function HomePageDetail({
  trail,
  onChange,
}: {
  trail: readonly string[] | null
  onChange: () => void
}) {
  return (
    <>
      {trail ? (
        <FavoriteTrail parts={trail} isActive={false} />
      ) : (
        <span className="text-[color:var(--sidebar-submenu-text-faint)]">…</span>
      )}
      <IconButton
        label="Change Home Page"
        onClick={onChange}
        className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-[color:var(--sidebar-submenu-text-faint)] transition-colors hover:bg-[color:var(--sidebar-item-hover-bg)] hover:text-[color:var(--sidebar-submenu-text-default)]"
      >
        <EditIcon size={14} aria-hidden="true" />
      </IconButton>
    </>
  )
}
